var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7157 26.2882L21.7537 20.3132C23.1667 18.5882 24.0157 16.3882 24.0157 13.9882C24.0157 8.47628 19.5277 3.98828 14.0157 3.98828C8.50362 3.98828 4.01562 8.47628 4.01562 13.9882C4.01562 19.5002 8.50362 23.9882 14.0157 23.9882C16.4157 23.9882 18.6157 23.1382 20.3407 21.7262L26.3027 27.6882C26.4777 27.8632 26.7277 27.9762 27.0147 27.9762C27.5647 27.9762 28.0147 27.5262 28.0147 26.9762C28.0027 26.7262 27.8907 26.4762 27.7157 26.2882ZM14.0037 22.0002C9.59163 22.0002 6.00362 18.4132 6.00362 14.0002C6.00362 9.58728 9.59163 6.00028 14.0037 6.00028C18.4157 6.00028 22.0037 9.58828 22.0037 14.0002C22.0037 18.4122 18.4167 22.0002 14.0037 22.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.1d16e10df7c6ee39d95fed50d00d4cc9.svg";
export { ForwardRef as ReactComponent };